/**
 * Mirinae Selection Utility
 * 
 * Wraps browser Selection API to provide stable range handling for the Rich Text Editor.
 * Helps with:
 * 1. Saving/Restoring cursor position (crucial for contenteditable)
 * 2. Applying formatting commands safely (Polyfills execCommand)
 */

export const MirinaeSelection = {
    /**
     * Returns the current selection ragne if it is inside the specified container.
     * @param {HTMLElement} container 
     * @returns {Range|null}
     */
    getRange(container) {
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return null;

        const range = selection.getRangeAt(0);

        // Check if selection is within container
        if (container.contains(range.commonAncestorContainer)) {
            return range;
        }
        return null;
    },

    /**
     * Restores a previously saved range.
     * @param {Range} range 
     */
    restoreRange(range) {
        if (!range) return;
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
    },

    /**
     * Executes a standard execCommand for styling (Bold, Italic).
     * Attempts to use 'styleWithCSS' to generate modern <span> tags instead of <font>.
     * @param {string} command - 'bold', 'italic', 'foreColor', etc.
     * @param {string} value - Argument for command (e.g. color hex)
     */
    applyStyle(command, value = null) {
        if (typeof document.execCommand === 'function') {
            try {
                // Try modern style generation
                document.execCommand('styleWithCSS', false, true);
            } catch (e) {
                // Ignore failure
            }
            document.execCommand(command, false, value);
        }
    },

    /**
     * Checks if functionality is supported
     */
    isSupported() {
        return typeof document.execCommand === 'function';
    }
};
